<template>
  <div>
    <wc-page-title title='Legacy Statements'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Legacy Statements'
            titleIcon='mdi-check-all'
            :titleIconColor='toolbarData.iconColor'
            :loading='isLoading'
            :showAdd='!currentDivision.is_all'
            @add='newRec'
            @toggleShowArchived='toggleShowArchived'
          >
              <v-data-table
                dense
                :items='recs'
                :headers='headers'
                :rows-per-page='20'
                @click:row='openRec'
              >
                <template v-slot:item.account_obj.name='{ item }'>
                  {{ item.from_date | shortDate }}
                </template>
                <template v-slot:item.to_date='{ item }'>
                  {{ item.to_date | shortDate }}
                </template>
                <template v-slot:item.account_obj.name='{ item }'>
                  {{ item.account_obj.name }}
                  <v-icon small color='red' class='ml-5' v-if='item.is_locked'>mdi-lock</v-icon>
                </template>
                <template v-slot:item.end_balance='{ item }'>
                  {{ item.end_balance | decMoney }}
                </template>
              </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>

      <wc-dialog
        :showDialog='showDialog'
        title='New Reconciliation'
        :icon='toolbarData.icon'
        :iconColr='toolbarData.iconColor'
        width='350'
        :loading='isSaving'
        :disableButtons='!isFormValid'
        @cancel='showDialog = false'
        saveText='Continue'
        @save='saveRec'
      >
        <v-form v-model='isFormValid' ref='form'>
          <v-select
            :items='accounts'
            item-text='name'
            item-value='id'
            label='Account'
            :rules='[rules.required]'
            v-model='recCopy.account'
            persistent-hint
          ></v-select>
          <br>
          <wc-datepicker
            label='From date:'
            required
            v-model='recCopy.from_date'
          ></wc-datepicker>
          <wc-datepicker
            label='To date:'
            required
            v-model='recCopy.to_date'
          ></wc-datepicker>
          <br>
          <v-text-field
            label='Ending balance'
            :rules='[rules.decimal]'
            v-model='recCopy.end_balance'
          ></v-text-field>
        </v-form>
      </wc-dialog>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import formRules from '@/mixins/formRules';

export default {
  name: 'all-deposits',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    showArchived: false,
    showDialog: false,
    testPicker: { date: '' },
    accounts: [],
    recs: [],
    currentDivision: {},
    recCopy: {
      from_date: '',
      to_date: '',
      account: null,
      end_balance: ''
    },
    headers: [
      { text: 'Account', value: 'account_obj.name' },
      { text: 'Start Date', value: 'from_date', align: 'center', width: '150'},
      { text: 'End Date', value: 'to_date', align: 'center', width: '150'},
      { text: 'End Balance', value: 'end_balance', align: 'right' }
    ]
  }),
  computed: {
    toolbarData () {
      return this.$store.state.icons.dataBox.bankRecs
    }
  },
  mounted () {
    this.getData();
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.recs = await accountingAPI.getLegacyStatements();
      this.accounts = await accountingAPI.getAccounts();
      this.isLoading = false
    },
    toggleShowArchived () {
      this.showArchived = !this.showArchived
    },
    resetRecCopy () {
      this.recCopy.date = null
      this.recCopy.account = null
      this.recCopy.end_balance = ''
    },
    newRec () {
      this.resetRecCopy()
      this.showDialog = true
    },
    async saveRec () {
      this.isSaving = true;
      let tmp = await accountingAPI.createReconciliation(this.recCopy);
      this.openRec(tmp);
    },
    openRec (row) {
      this.$router.push({ name: 'StatementDetail', params: { id: row.id } })
    }
  }
}
</script>
